import { apiClients } from '../apiClients';
import { ApiClient } from '../lib/ApiClient';
import { TwitchBitsTransaction } from '../types/TwitchExtension';

export class StreamerService {
	private static get streamerApi(): ApiClient {
		if (!apiClients.streamerApi) {
			throw new Error('Streamer API client not initialized');
		}

		return apiClients.streamerApi;
	}

	public static async changeVoiceBits(
		voiceId: string,
		voiceTime: number,
		transactionTicket: TwitchBitsTransaction,
	): Promise<void> {
		const response = await StreamerService.streamerApi.request<void>({
			path: `/v1/streamer/change-voice-bits`,
			method: 'POST',
			body: JSON.stringify({
				voiceId,
				voiceTime,
				transaction: transactionTicket,
			}),
			headers: {
				'content-type': 'application/json',
			},
		});

		if (!response.ok) {
			throw new Error('Failed to change voice bits');
		}
	}
}
